/**
 * Campaigns for which the browser History API screen mechanism is enabled.
 *
 * The app installs a global `popstate` guard (see App.js) that normally
 * "traps" the user on a page so the system Back button cannot accidentally
 * leave it. For pages that manage their screens through `useScreenHistory`
 * that guard must be disabled so Back/Forward can walk the internal screens
 * (and leave the page from the root screen).
 *
 * To enable the mechanism on a new page:
 *   1. use the `useScreenHistory` hook on that page, and
 *   2. add the page's exact `utm_campaign` code to this list.
 *
 * NOTE: the reference campaign `24UA-PRL-S` keeps its original, broader
 * detection (URL substring + isQrCode) so its behavior is preserved exactly.
 * New campaigns use an EXACT match (against `utm_campaign` or the `isQrCode`
 * route key) to avoid matching longer variants (e.g. `24UA-PRL-N-LPE`).
 */
export const HISTORY_ENABLED_CAMPAIGNS = [
  '24UA-PRL-N',
  '24UA-PRL-A',
  '24UA-PRL-P',
  '26UA-PRL-S-L',
  '26UA-PRL-A-L',
  '24UA-BND-B'
];

export const isHistoryEnabledCampaign = () => {
  const utmCampaign = sessionStorage.getItem('utm_campaign');
  const isQrCode = sessionStorage.getItem('isQrCode');

  // Reference campaign — preserve the original detection exactly.
  if (
    window.location.href.includes('24UA-PRL-S') ||
    utmCampaign === '24UA-PRL-S' ||
    isQrCode === '24UA-PRL-S'
  ) {
    return true;
  }

  // Additional campaigns — exact match on either the utm_campaign param
  // (query-based routes) or the isQrCode route key (path-based routes).
  return (
    HISTORY_ENABLED_CAMPAIGNS.includes(utmCampaign) ||
    HISTORY_ENABLED_CAMPAIGNS.includes(isQrCode)
  );
};
